import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import EchartLine from '../dashboard/echart';
import { ProjectionMiniChart, InsightCards, statusColor, SensorSparkline } from '../dashboard/chartPrimitives';
import FeedAnalysisModal from '../dashboard/FeedAnalysisModal';
import SensorTrendModal from '../dashboard/SensorTrendModal';
import { bound } from '../dashboard/sensorInsights';
import MaterialIcon, { colorPalette } from 'material-icons-react';
import { env } from './const';
import { useLoading, Bars, ThreeDots } from '@agney/react-loading';
import { faLineChart } from "@fortawesome/free-solid-svg-icons";
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import moment from 'moment-timezone';
import { getRole, headers, watermeter, controls } from '../utils/common';
import { getUserName } from '../utils/common';
import DeviceConnections from "./DeviceConnections";
import * as apiInstance from '../utils/axiosinstace';
import { Role } from "../utils/role";

//import 'select2/dist/css/select2.min.css';
import $ from 'jquery';
import 'select2';

// The Today's Trends tab is superseded by the per-sensor trend modals behind
// the chart icon on each Barn Monitor tile: same four charts, same day's data,
// plus heat index, one click closer. Kept behind a flag rather than deleted so
// it can be brought back without rebuilding the chart tiles.
const SHOW_TRENDS_TAB = false;

// Sparkline stroke per tile status. Same hexes as .sensorTile's border-top in
// App.css, so the strip and the card edge always agree.
const SPARK_COLOR = { ok: '#28a745', high: '#c82333', low: '#0d6efd', idle: '#9aa0c0' };

const Dashboard = () => {
  const { t } = useTranslation(['dashboard', 'common']);
  const [show, setShow] = useState(false);
  const [role, seRole] = useState(getRole());
  const [notification, setNotification] = useState({ title: "", body: "" });
  const [headersobj] = useState(headers());
  const [tempState, setTempState] = useState([]);

  const [xData, setXData] = useState([]);
  const [rhState, setRHState] = useState([]);
  const [coState, setCOState] = useState([]);
  const [nhState, setNHState] = useState([]);
  const [hiState, setHIState] = useState([]);
  // Epoch ms per reading, used for DURATIONS only (see setSensorTimes below).
  const [sensorTimes, setSensorTimes] = useState([]);

  const [batchStatus, setBatchStatus] = useState('');
  const [showLoader, setShowLoader] = useState(false);

  let today = moment().tz('Asia/Singapore').format("YYYY-MM-DD");
  const initial_dbvals = {
    "mintemp": 0,
    "maxtemp": 0,
    "avgtemp": 0,
    "maxrh": 0,
    "minrh": 0,
    "avgrh": 0,
    "maxco": 0,
    "minco": 0,
    "avgco": 0,
    "minnh": 0,
    "maxnh": 0,
    "avgnh": 0,
    "minhi": 0,
    "maxhi": 0,
    "avghi": 0,
    "lasteUpdated": ""
  };
  const initial_currvals = {
    "temp": 0,
    "rh": 0,
    "co": 0,
    "nh": 0,
    "hi": 0
  }
  const [phaseNumber, setPhaseNumber] = useState(0);
  const [currDay, setCurrDay] = useState(0);
  const [dashboardValues, setDashboardValues] = useState(initial_dbvals);
  const [currValues, setCurrValues] = useState(initial_currvals);
  const [thresholds, setThresholds] = useState(
    {
      "tempMin": 22,
      "tempMax": 32,
      "rhMin": 50,
      "rhMax": 70,
      "coMin": 0,
      "coMax": 2500,
      "nhMin": 0,
      "nhMax": 15
    }
  );
  const history = useHistory();
  const [selectedFarm, setSelectedFarm] = useState(null);
  const [addWeigtFeedStatus, setAddWeigtFeedStatus] = useState({});
  const [deviceID, setDeviceID] = useState('');
  const [signalStrength, setSignalStrength] = useState(0);
  const [sexing, setSexing] = useState('no');
  const [male, setMale] = useState(0);
  const [female, setFemale] = useState(0);
  const [batchWeights, setBatchWeights] = useState({
    "weight": 0, "feed": 0, "mortality": 0, "idealweight": 0,
    "weightStatus": false, "feedStatus": false, "mortalityStatus": false,
    "numberofBirds": 0, "numberofLiveBirds": 0
  });

  const [waterConsumptiomn, setWaterConsumption] = useState({
    "today": 0,
    "lastHr": 0,
    "total": 0,
    "perBird_today": 0,
    "perBird_total": 0
  });

  const [farmData, setFarmData] = useState([]);
  const [farmerData, setFarmerData] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [fanInfo, setFanInfo] = useState([]);
  const initial_forecast_block = {
    status: 'NA', reason: '',
    today_actual: null, today_ideal: null, current_fcr: null, ideal_today: null,
    predicted_final: null,
    chart: { days: [], actual: [], ideal: [] },
  };
  const initial_forecast = {
    weight: { ...initial_forecast_block },
    fcr: { ...initial_forecast_block },
    weight_male: { ...initial_forecast_block },
    weight_female: { ...initial_forecast_block },
    fcr_male: { ...initial_forecast_block },
    fcr_female: { ...initial_forecast_block },
    fcr_hatched: { ...initial_forecast_block },
  };
  const [forecast, setForecast] = useState(initial_forecast);
  const [duration, setDuration] = useState(0);
  const signals = useRef(() => { });
  const devID = useRef('');
  function defaultValues() {
    setDashboardValues(prevState => {
      return { ...prevState, ...initial_dbvals };
    });
    setCurrValues(prevState => {
      return { ...prevState, ...initial_currvals };
    });
    setDeviceID('');
    setTempState([]);
    setXData([]);
    setRHState([]);
    setCOState([]);
    setNHState([]);
    setHIState([]);
    setSensorTimes([]);
    setThresholds({
      tempMin: 22,
      tempMax: 32,
      rhMin: 50,
      rhMax: 70,
      coMin: 0,
      coMax: 2500,
      nhMin: 0,
      nhMax: 15
    });
    setPhaseNumber('N/A');
    setCurrDay('N/A');
    setBreedName('N/A');
    setLastUpdatedat('N/A');
    setBatchStatus('');
    setSignalStrength(0);
    setSignalStatus('gray');
    setFanInfo([]);
    setSexing('');
    setMale('');
    setFemale('');
    setWaterConsumption({
      "today": 0,
      "lastHr": 0,
      "total": 0,
      "perBird_today": 0,
      "perBird_total": 0
    });
    setBatchWeights({
      "weight": 0, "feed": 0, "mortality": 0, "idealweight": 0,
      "weightStatus": false, "feedStatus": false, "mortalityStatus": false,
      "numberofLiveBirds": 0
    })
    setForecast(initial_forecast);
    setDuration(0);
  }
  const [breedName, setBreedName] = useState('');
  const [lastUpdated, setLastUpdatedat] = useState('');
  const fetchValues = useRef(() => { });
  const [currentDay, setCurrentDay] = useState('');
  fetchValues.current = async (farmID) => {
    let fid = '';

    if (farmID !== undefined) {
      fid = farmID;
    } else {
      fid = selectedFarm;
    }
    if (fid == undefined) {
      return
    }

    setShowLoader(true);
    try {
      // The await belongs INSIDE the try. It used to sit above it, so a network
      // blip or an expired token rejected before the catch could run: the catch
      // never fired, setShowLoader(false) never fired, and the header spinner
      // span forever on a dashboard nobody was watching.
      const values = await apiInstance.getDashBoardValues(fid, today);
      setShowLoader(false);
      devID.current = values.deviceID;
      signals.current();
      //alert(JSON.stringify(values))
      setCurrDay(values.day);
      setCurrentDay(values.currentDay);
      setBreedName(values.breed);
      setSexing(values.sexing);
      setMale(values.male);
      setFemale(values.female);
      setLastUpdatedat(values.lastUpdated);
      setPhaseNumber(values.phaseID);
      setTempState(values.chartData.tempData);
      setXData(values.chartData.xData);
      setRHState(values.chartData.rhData);
      setCOState(values.chartData.coData);
      setNHState(values.chartData.nhData);

      // Heat index has no chartData array -- routes/dashboard.js never pushes
      // reading.hi into one -- but the raw rows it is taken from are already in
      // the payload, and are index-aligned with chartData/xData because both
      // are built by the same forEach. Deriving it here means the sparkline and
      // trend modal need no API change at all.
      const rows = Array.isArray(values.deviceReadings) ? values.deviceReadings : [];
      setHIState(rows.map((r) => Number(r.hi)));
      // Timestamps back the "longest spell out of range" insight. They are used
      // for DIFFERENCES only, never for display: xData is already formatted
      // server-side in Asia/Singapore, and re-deriving labels here would shift
      // them by the viewer's own timezone.
      setSensorTimes(rows.map((r) => new Date(r.createdDate).getTime()));

      if (values.getMinMax.length > 0) {
        setThresholds(values.getMinMax[0]);
      }

      setBatchWeights(values.chickWeightFeed);
      setWaterConsumption(values.waterConsumption);
      setFanInfo(values.fanInfo);
      if (values.forecast) setForecast(prev => ({ ...prev, ...values.forecast }));
      if (values.duration !== undefined) setDuration(values.duration);
      if (values.dashboardValues.length > 0) {
        setDashboardValues(prevState => {
          return { ...prevState, ...values.dashboardValues[0] };
        });

      } else {
        setDashboardValues(prevState => {
          return { ...prevState, ...initial_dbvals };
        });
      }
      if (values.currValues.length > 0) {
        setCurrValues(prevState => {
          return { ...prevState, ...values.currValues[0] };
        });
      } else {
        setCurrValues(prevState => {
          return { ...prevState, ...initial_currvals };
        });
      }

      if (values.batchExceeded) {
        setCurrDay(0);
        setPhaseNumber(0);
        setBatchStatus('Batch exceeded duration');
        // devID.current = '';
        // setSignalStatus('gray');
        // devID.current = '';
        //defaultValues();
      } else {
        setBatchStatus('');
      }
    } catch (err) {
      setShowLoader(false);
      console.log(err.message);
      devID.current = '';
      defaultValues();
    }
    // .then(res=>{
    //    console.log(res.data);
    //    setShowLoader(false);
    //    if(!res.data.batchExceeded) {
    //    devID.current = res.data.deviceID;
    //    signals.current();
    //    setCurrDay(res.data.day);
    //    setCurrentDay(res.data.currentDay);
    //    setBreedName(res.data.breed);
    //    setSexing(res.data.sexing);
    //    setMale(res.data.male);
    //    setFemale(res.data.female);
    //    setLastUpdatedat(res.data.lastUpdated);
    //    setPhaseNumber(res.data.phaseID);
    //    setTempState(res.data.chartData.tempData);
    //    setXData(res.data.chartData.xData);
    //    setRHState(res.data.chartData.rhData);
    //    setCOState(res.data.chartData.coData);
    //    setNHState(res.data.chartData.nhData);
    //    setThresholds(res.data.getMinMax);
    //    console.log(JSON.stringify(res.data.chickWeightFeed));
    //    console.log(JSON.stringify(res.data.dashboardValues))
    //    setBatchWeights(res.data.chickWeightFeed);
    //    setWaterConsumption(res.data.waterConsumption);
    //    setFanInfo(res.data.fanInfo);
    //    if(res.data.dashboardValues.length>0) {
    //     setDashboardValues(prevState => {
    //         return {...prevState, ...res.data.dashboardValues[0]};
    //     });

    //    } else {
    //     setDashboardValues(prevState => {
    //         return {...prevState, ...initial_dbvals};
    //     });
    //    }
    //     if (res.data.currValues.length>0) {
    //         setCurrValues(prevState => {
    //             return {...prevState, ...res.data.currValues[0]};
    //         });
    //     } else {
    //         setCurrValues(prevState => {
    //             return {...prevState, ...initial_currvals};
    //         });
    //     }
    //     setBatchStatus('');
    // } else {
    //     setCurrDay(0);
    //     setPhaseNumber(0);
    //     setBatchStatus('Batch exceeded duration');

    //     devID.current = '';
    //     setSignalStatus('gray');
    //     devID.current = '';
    //     defaultValues();
    // }

    // }).catch((err) =>{
    //     setShowLoader(false);
    //      console.log(err.message);
    //      devID.current = '';
    //      defaultValues();
    // });
  }
  const [signalStatus, setSignalStatus] = useState('red');

  signals.current = async () => {
    try {
      const response = await apiInstance.getSignalData(devID.current);
      const _signalStrength = Math.abs(response.data.signalstrength);
      //alert(_signalStrength)
      setSignalStrength(_signalStrength);
      if (response.data.status === false) {
        setSignalStrength(0);
        setSignalStatus('gray');
        return;
      }

      if (_signalStrength === 0) {
        setSignalStatus('gray');
      } else if (_signalStrength <= 85) {
        setSignalStatus('green');
      } else if (_signalStrength > 85 && _signalStrength < 95) {
        // alert('Yellow')
        setSignalStatus('yellow');
      } else {
        setSignalStatus('red');
      }
    } catch (err) {
      // setError(err.message || 'An error occurred while adding the barn.');
      setSignalStrength(0);
      setSignalStatus('gray');
      console.log(err.message);
    } finally {
      // setLoading(false);
    }
  }

  // Polling lives in its own effect with a real cleanup. It used to sit inside
  // the list-loading effect below, whose deps included signalStatus -- which
  // signals.current() itself sets. Every status flip re-ran that effect and
  // started ANOTHER pair of intervals on top of the ones already running, with
  // no clearInterval anywhere, so a dashboard left open for a few hours ended
  // up polling many times a minute. Both callees are refs, so [] is correct
  // here: they are reassigned every render and never go stale.
  useEffect(() => {
    const signalTimer = setInterval(() => {
      signals.current();
    }, 3 * 60 * 1000);

    const valuesTimer = setInterval(() => {
      fetchValues.current(undefined);
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(signalTimer);
      clearInterval(valuesTimer);
    };
  }, []);

  useEffect(() => {
    const trees = window.$('[data-widget="treeview"]');
    trees.Treeview('init');

    if (role === Role.Admin) {
      // Only farmers with a barn running a started batch. The plain
      // /misc/listoffarmers is every farmer ever created (~90 and growing),
      // most of them idle, which made this dropdown unusable. It stays
      // unfiltered for Add Batch / Add User / Assign Devices, which need
      // idle farmers -- see routes/misc.js.
      axios
        .get(env.produrl + "/misc/listoffarmers/active", { headers: headersobj })
        .then((res) => {
          setFarmerData(res.data.list);
          if (res.data.list.length > 0 && selectedFarmer == null) {
            const firstFarmer = res.data.list[0];
            setSelectedFarmer(firstFarmer.id);

            // Fetch farms and filter by first farmer's ID
            fetchFarmsByFarmer(firstFarmer.id);
          }
        })
        .catch((err) => console.log(err.message));
    } else {
      // Non-admin role: Fetch farms without filtering
      axios
        .get(env.produrl + "/misc/listoffarmsDashboard/" + getUserName(), {
          headers: headersobj,
        })
        .then((res) => {
          setFarmData(res.data.list);
          if (res.data.list.length > 0 && selectedFarm == null) {
            const firstFarm = res.data.list[0];
            setSelectedFarm(firstFarm.farmID);
            fetchValues.current(firstFarm.farmID);
          }
        })
        .catch((err) => console.log(err.message));
    }
  }, [headersobj, role]);
  const alertShown = useRef(false);
  const fetchFarmsByFarmer = (farmerID) => {
    axios
      .get(env.produrl + "/misc/listoffarmsDashboard/" + getUserName(), { headers: headersobj })
      .then((farmRes) => {
        const farmsForFarmer = farmRes.data.list.filter(
          (farm) => farm.farmerID == farmerID
        );
        setFarmData(farmsForFarmer);

        if (farmsForFarmer.length > 0) {
          const firstFarm = farmsForFarmer[0];
          setSelectedFarm(firstFarm.farmID);
          fetchValues.current(firstFarm.farmID);
          alertShown.current = false; // Reset the alert flag
        } else if (!alertShown.current) {
          alert(t('dashboard:empty.noBarnsFound'));
          alertShown.current = true;
          setFarmData([]);
          setSelectedFarm(null);
          setCurrDay('NA');
          setCurrentDay('N/A');
          setPhaseNumber('N/A')
          defaultValues();
        }
      })
      .catch((err) => console.log(err.message));
  };

  const onChangeHandler = (selectedItem) => {

    setSelectedFarm(selectedItem);
    fetchValues.current(selectedItem)
  }

  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Bars width="22" color="#333" />,
  })
  const percentage = (value, total) => (value / total) * 100;
  useEffect(() => {
    const farmSelect = $("#selectFarm").select2();
    const farmerSelect = $("#selectFarmer").select2();

    // Handle farm selection.
    //
    // Going through onChangeHandler (rather than calling fetchValues directly)
    // is what keeps selectedFarm in step, and that is load-bearing: the
    // 5-minute poll calls fetchValues.current(undefined), which falls back to
    // the selectedFarm STATE. select2 announces a pick by jQuery-triggering
    // 'change', which React's root listener never sees, so the <select>'s own
    // onChange does not fire here. Without this, selectedFarm stayed pinned to
    // whatever was set programmatically on load and the next poll silently
    // swapped the page back to that first barn -- while the dropdown went on
    // showing the barn the user had actually chosen.
    farmSelect.on("select2:select", (event) => {
      onChangeHandler(event.params.data.id);
    });

    // Handle farmer selection
    farmerSelect.on("select2:select", (event) => {

      setSelectedFarmer(event.params.data.id);
      fetchFarmsByFarmer(event.params.data.id)
    });

    // Clean-up
    return () => {
      farmSelect.select2("destroy");
      farmerSelect.select2("destroy");
    };
  }, []);

  // Daily-entry modals (Mortality / Bird Weight / Feed)
  const [mortalityOpen, setMortalityOpen] = useState(false);
  const [weightOpen, setWeightOpen] = useState(false);
  const [feedOpen, setFeedOpen] = useState(false);

  // Forecast detail modal (chart drawer)
  const [forecastModalKind, setForecastModalKind] = useState(null); // 'weight' | 'fcr' | null
  // Feed analysis fetches its own data on open, so it needs only a boolean.
  const [feedAnalysisOpen, setFeedAnalysisOpen] = useState(false);
  // Sensor trend modal — holds the SENSORS key ('temp' | 'rh' | 'hi' | 'nh' | 'co').
  const [sensorModalKey, setSensorModalKey] = useState(null);
  const closeMortality = () => setMortalityOpen(false);
  const closeWeight = () => setWeightOpen(false);
  const closeFeed = () => setFeedOpen(false);

  const submitDailyEntry = async (rows) => {
    if (!batchWeights || !batchWeights.batchID || !selectedFarm) {
      alert(t('dashboard:empty.activeBatchNotLoaded'));
      return false;
    }
    const payload = rows
      .filter(r => r.value !== '' && r.value !== undefined && r.value !== null)
      .map(r => ({
        weight: r.value,
        farmID: selectedFarm,
        batchID: batchWeights.batchID,
        date: today,
        type: r.type,
      }));
    if (payload.length === 0) return false;
    try {
      await apiInstance.addDailyParams(payload);
      await fetchValues.current(undefined);
      return true;
    } catch (e) {
      alert(t('dashboard:entry.couldNotSave') + ' ' + (e?.message || ''));
      return false;
    }
  };

  const mortalityLocked = !!(
    batchWeights.mortalityStatus ||
    batchWeights.mortality_male_status || batchWeights.mortality_female_status ||
    batchWeights.culling_status || batchWeights.culling_male_status || batchWeights.culling_female_status
  );
  const weightLocked = !!(
    batchWeights.weightStatus ||
    batchWeights.chickWeight_male_status || batchWeights.chickWeight_female_status
  );
  const feedLocked = !!batchWeights.feedStatus;

  // Threshold check — 'idle' (no data), 'low' (< min), 'high' (> max), 'ok' (in range)
  const getSensorStatus = (value, min, max) => {
    const v = Number(value);
    if (!Number.isFinite(v) || v === 0) return 'idle';
    if (Number.isFinite(Number(min)) && v < Number(min)) return 'low';
    if (Number.isFinite(Number(max)) && v > Number(max)) return 'high';
    return 'ok';
  };
  const tempStatus = getSensorStatus(currValues.temp, thresholds.tempMin, thresholds.tempMax);
  const rhStatus = getSensorStatus(currValues.rh, thresholds.rhMin, thresholds.rhMax);
  const coStatus = getSensorStatus(currValues.co, thresholds.coMin, thresholds.coMax);
  const nhStatus = getSensorStatus(currValues.nh, thresholds.nhMin, thresholds.nhMax);
  // Heat index reads the LATEST value like its four neighbours (it used to show
  // dashboardValues.avghi, the whole day's average, which made it the only tile
  // in the row not reporting "now" and left its sparkline's end point unable to
  // match its big number).
  //
  // 'low' is then folded into 'ok' for this sensor alone. Heat index is a heat
  // STRESS index: the 82/86 band marks the onset of stress, so below 82 is
  // comfortable, not a fault. Left as-is it would also flap -- the live reading
  // crosses 82 many times on an ordinary day where the day average never did,
  // flipping the badge, the tile border and the sparkline colour every poll.
  const hiRaw = getSensorStatus(currValues.hi, thresholds.hiMin, thresholds.hiMax);
  const hiStatus = hiRaw === 'low' ? 'ok' : hiRaw;
  const warnBadge = (status) => {
    if (status === 'high') return <span className="statusBadge high"><MaterialIcon icon="arrow_upward" size={11} color="#c82333" />{t('dashboard:status.high')}</span>;
    if (status === 'low') return <span className="statusBadge low"><MaterialIcon icon="arrow_downward" size={11} color="#084298" />{t('dashboard:status.low')}</span>;
    return null;
  };

  // Forecast helpers
  const forecastStatusMap = {
    'Ahead of Target': { cls: 'ahead', label: t('dashboard:status.aheadOfTarget'), icon: 'arrow_upward' },
    'On Track':        { cls: 'ontrack', label: t('dashboard:status.onTrack'), icon: 'fiber_manual_record' },
    'Behind Target':   { cls: 'behind', label: t('dashboard:status.behindTarget'), icon: 'arrow_downward' },
    'NA':              { cls: 'na', label: t('dashboard:empty.noForecast'), icon: 'radio_button_unchecked' },
  };
  const forecastChip = (status) => {
    const s = forecastStatusMap[status] || forecastStatusMap['NA'];
    return (
      <span className={`forecastChip ${s.cls}`}>
        <MaterialIcon icon={s.icon} color="#fff" size={12} />
        {s.label}
      </span>
    );
  };
  const fmtNum = (v, decimals = 2) => {
    if (v === null || v === undefined || v === '' || isNaN(Number(v))) return '—';
    return Number(v).toFixed(decimals);
  };
  const valOrNA = (v, decimals = 2, reason) => {
    if (v === null || v === undefined || v === '' || isNaN(Number(v))) {
      return <span className="naTag" title={reason || 'No forecast data available yet.'}>N/A</span>;
    }
    return Number(v).toFixed(decimals);
  };
  const fmtDelta = (actual, ideal, decimals = 3, inverse = false) => {
    if (actual === null || actual === undefined || ideal === null || ideal === undefined) return null;
    const d = Number(actual) - Number(ideal);
    if (isNaN(d)) return null;
    const good = inverse ? d < 0 : d > 0;
    const cls = d === 0 ? 'deltaNeutral' : good ? 'deltaGood' : 'deltaBad';
    const sign = d > 0 ? '+' : '';
    return <span className={cls}>{sign}{d.toFixed(decimals)} vs ideal</span>;
  };

  // Info icon showing what measurement the forecast was based on (handy when is_fallback is true).
  const measuredInfo = (block, id) => {
    if (!block || block.measured_on_day == null) return null;
    const datePart = block.measured_on_date ? ` (${block.measured_on_date})` : '';
    const tip = `Forecast based on last measurement — Day ${block.measured_on_day}${datePart}`;
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 50, hide: 100 }}
        overlay={<Tooltip id={`measured-${id}`} className="measuredTooltip">{tip}</Tooltip>}
      >
        <span className="measuredInfo">
          <MaterialIcon icon="info_outline" size={13} color="#9aa0c0" />
        </span>
      </OverlayTrigger>
    );
  };

  // Shared empty-state block for the trend charts
  const emptyChartState = (
    <div className="noDataState">
      <MaterialIcon icon="query_stats" color="#c5c8df" size={56} />
      <div className="noDataText">{t('dashboard:empty.noDataAvailable')}</div>
      <div className="noDataHint">{t('dashboard:empty.waitingForReadings')}</div>
    </div>
  );

  // One table drives the five sensor tiles AND the trend modal, so the two can
  // never drift apart. `icon` is a React node rather than a path because Heat
  // Index is the odd one out: it uses a MaterialIcon where the other four use
  // an <img>.
  //
  // `minSpan` and `deadband` are per-sensor because the units are not
  // comparable -- 0.3 is rounding noise on temperature and a real move on
  // ammonia. minSpan stops a flat day being magnified into a mountain range by
  // the sparkline's auto-scaling; deadband is the threshold below which the
  // insights call a change "steady".
  //
  // Units stay exactly as this dashboard has always shown them: °C, %, and
  // nothing at all for heat index, ammonia and CO2. Heat index is a unitless
  // index, and nothing in the payload asserts ppm for the two gases, so
  // inventing a unit here would be a silent data claim.
  const SENSORS = [
    { key: 'temp', labelKey: 'common:sensors.temperature', unit: '°C',
      icon: <img src="/dist/img/celsius.png" alt="" />,
      decimals: 1, deadband: 0.3, minSpan: 4,
      value: currValues.temp, series: tempState, status: tempStatus,
      dayMin: dashboardValues.mintemp, dayMax: dashboardValues.maxtemp, dayAvg: dashboardValues.avgtemp,
      lo: bound(thresholds.tempMin), hi: bound(thresholds.tempMax) },
    { key: 'rh', labelKey: 'common:sensors.humidity', unit: '%',
      icon: <img src="/dist/img/humidity.png" alt="" />,
      decimals: 1, deadband: 1, minSpan: 15,
      value: currValues.rh, series: rhState, status: rhStatus,
      dayMin: dashboardValues.minrh, dayMax: dashboardValues.maxrh, dayAvg: dashboardValues.avgrh,
      lo: bound(thresholds.rhMin), hi: bound(thresholds.rhMax) },
    { key: 'hi', labelKey: 'common:sensors.heatIndex', unit: '',
      icon: <MaterialIcon icon="thermostat" color="#292970" size={20} />,
      decimals: 1, deadband: 0.5, minSpan: 6,
      value: currValues.hi, series: hiState, status: hiStatus,
      dayMin: dashboardValues.minhi, dayMax: dashboardValues.maxhi, dayAvg: dashboardValues.avghi,
      lo: bound(thresholds.hiMin), hi: bound(thresholds.hiMax) },
    { key: 'nh', labelKey: 'common:sensors.ammonia', unit: '',
      icon: <img src="/dist/img/ammonia.png" alt="" />,
      decimals: 1, deadband: 1, minSpan: 6,
      value: currValues.nh, series: nhState, status: nhStatus,
      dayMin: dashboardValues.minnh, dayMax: dashboardValues.maxnh, dayAvg: dashboardValues.avgnh,
      lo: bound(thresholds.nhMin), hi: bound(thresholds.nhMax) },
    { key: 'co', labelKey: 'common:sensors.co2', unit: '',
      icon: <img src="/dist/img/co2-cloud.png" alt="" />,
      decimals: 0, deadband: 50, minSpan: 400,
      value: currValues.co, series: coState, status: coStatus,
      dayMin: dashboardValues.minco, dayMax: dashboardValues.maxco, dayAvg: dashboardValues.avgco,
      lo: bound(thresholds.coMin), hi: bound(thresholds.coMax) },
  ];
  const activeSensor = SENSORS.find((s) => s.key === sensorModalKey) || null;

  // The tab strip only earns its space when there is more than one tab to
  // switch between. Device Connections is Admin-only, so with Today's Trends
  // off a non-admin has a single panel and gets it without any strip. Keyed off
  // SHOW_TRENDS_TAB too, so re-enabling that tab restores the strip for
  // everyone rather than silently hiding it from non-admins.
  const showTabs = role == Role.Admin || SHOW_TRENDS_TAB;

  // The Barn Monitor panel, lifted out of the tab so it can also render on
  // its own. A Farmer/Worker/Digiviewer has exactly one panel to look at,
  // and a one-item tab strip above it is chrome with nothing to switch to.
  const barnMonitorPanel = (
    <>
          {/* Sensor row — 5 tile cards, driven by the SENSORS table above */}
          <div className="row tileGrid sensorRow">
            {SENSORS.map((s) => (
              <div className="col" key={s.key}>
                <div className={`tile sensorTile status-${s.status}`}>
                  <div className="tileHeader">
                    {s.icon}
                    <span className="sensorName">{t(s.labelKey)}</span>
                    {/* The badge and the button are wrapped rather than both
                        carrying margin-left:auto — two auto margins in a flex
                        row SPLIT the free space, which would strand the badge
                        mid-header. The wrapper owns the auto margin so the
                        header reads correctly whether or not warnBadge()
                        returns anything (it returns null when in range). */}
                    <span className="tileHeaderActions">
                      {warnBadge(s.status)}
                      <button
                        type="button"
                        className="forecastIconBtn"
                        title={t('dashboard:sensors.viewTrend')}
                        onClick={() => setSensorModalKey(s.key)}
                      >
                        <MaterialIcon icon="show_chart" color="#292970" size={18} />
                      </button>
                    </span>
                  </div>
                  <div className="tileBody sensorBody">
                    <div className="bigVal">
                      {s.value}
                      {s.unit ? <span className="unit">{s.unit}</span> : null}
                    </div>
                    <div className="rangeRow">
                      <span className="rangeMin">{t('common:metrics.min')} {s.dayMin}</span>
                      <span className="rangeMax">{t('common:metrics.max')} {s.dayMax}</span>
                    </div>
                  </div>
                  {/* Sibling of .sensorBody, not a child: that is what makes
                      the strip full-bleed, since .tileGrid .tileBody carries
                      padding that would otherwise inset it (and that padding
                      changes at the small breakpoint). .tileGrid .tile already
                      has overflow:hidden, so it clips to the rounded corners. */}
                  <div className="sensorSpark">
                    <SensorSparkline
                      values={s.series}
                      color={SPARK_COLOR[s.status] || SPARK_COLOR.idle}
                      minSpan={s.minSpan}
                      height={32}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tile Grid — row 1: Mortality | Bird Weight | Feed */}
          <div className="row tileGrid">
            <div className="col-md-3">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/chick.png" alt="" />
                  <span>{t('common:metrics.mortality')}</span>
                </div>
                <div className="tileBody">
                  {sexing == 'no' ?
                    <>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.currentStart')}</div>
                          <div className="statValue">
                            {isNaN(batchWeights.numberofLiveBirds) ? 0 : batchWeights.numberofLiveBirds.toLocaleString()}
                            <span className="statTotal">/{isNaN(batchWeights.numberofBirds) ? 0 : batchWeights.numberofBirds.toLocaleString()}</span>
                          </div>
                        </div>
                        <div className="statBlock danger">
                          <div className="statLabel">{t('common:metrics.totalMortality')}</div>
                          <div className="statValue">
                            {isNaN(batchWeights.mortality) ? 0 : batchWeights.mortality.toLocaleString()}
                            <span className="statSub">{isNaN(batchWeights.mortalityPercentage) ? 0 : batchWeights.mortalityPercentage}%</span>
                          </div>
                        </div>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('common:metrics.natural')}</span>
                        <span>
                          <span className="breakdownVal">{isNaN(batchWeights.natural) ? 0 : batchWeights.natural.toLocaleString()}</span>
                          <span className="breakdownPct">({isNaN(batchWeights.natural_percentage) ? 0 : batchWeights.natural_percentage}%)</span>
                        </span>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('common:metrics.culling')}</span>
                        <span>
                          <span className="breakdownVal">{isNaN(batchWeights.culling) ? 0 : batchWeights.culling.toLocaleString()}</span>
                          <span className="breakdownPct">({isNaN(batchWeights.culling_percentage) ? 0 : batchWeights.culling_percentage}%)</span>
                        </span>
                      </div>
                    </>
                    :
                    <>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.liveStart')}</div>
                          <div className="statValue">
                            {isNaN(batchWeights.numberofLiveBirds) ? 0 : batchWeights.numberofLiveBirds.toLocaleString()}
                            <span className="statTotal">/{isNaN(batchWeights.numberofBirds) ? 0 : batchWeights.numberofBirds.toLocaleString()}</span>
                          </div>
                        </div>
                        <div className="statBlock danger">
                          <div className="statLabel">{t('common:metrics.totalMortality')}</div>
                          <div className="statValue">
                            {isNaN(batchWeights.mortality) ? 0 : batchWeights.mortality.toLocaleString()}
                            <span className="statSub">{isNaN(batchWeights.mortalityPercentage) ? 0 : batchWeights.mortalityPercentage}%</span>
                          </div>
                        </div>
                      </div>
                      <div className="mortalityGrid">
                        <span></span>
                        <span className="mgHead">{t('common:metrics.total')}</span>
                        <span className="mgHead headMale">{t('common:gender.male')}</span>
                        <span className="mgHead headFemale">{t('common:gender.female')}</span>

                        <span className="mgRowLabel">{t('common:metrics.natural')}</span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.natural) ? 0 : batchWeights.natural.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.natural_percentage) ? 0 : batchWeights.natural_percentage}%</span>
                        </span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.mortality_male) ? 0 : batchWeights.mortality_male.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.mortality_male_percentage) ? 0 : batchWeights.mortality_male_percentage}%</span>
                        </span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.mortality_female) ? 0 : batchWeights.mortality_female.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.mortality_female_percentage) ? 0 : batchWeights.mortality_female_percentage}%</span>
                        </span>

                        <span className="mgRowLabel">{t('common:metrics.culling')}</span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.culling) ? 0 : batchWeights.culling.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.culling_percentage) ? 0 : batchWeights.culling_percentage}%</span>
                        </span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.culling_male) ? 0 : batchWeights.culling_male.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.culling_male_percentage) ? 0 : batchWeights.culling_male_percentage}%</span>
                        </span>
                        <span className="mgCell">
                          <span className="mgVal">{isNaN(batchWeights.culling_female) ? 0 : batchWeights.culling_female.toLocaleString()}</span>
                          <span className="mgPct">{isNaN(batchWeights.culling_female_percentage) ? 0 : batchWeights.culling_female_percentage}%</span>
                        </span>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/weighingscale.png" alt="" />
                  <span>{t('dashboard:panel.birdWeight')}</span>
                  <span className={`statusDotMini status-${forecastStatusMap[forecast.weight.status]?.cls || 'na'}`} title={forecastStatusMap[forecast.weight.status]?.label || t('dashboard:empty.noForecast')}></span>
                  <button type="button" className="forecastIconBtn" title={t('dashboard:fcr.viewForecastChart')} onClick={() => setForecastModalKind('weight')}>
                    <MaterialIcon icon="show_chart" color="#292970" size={18} />
                  </button>
                </div>
                <div className="tileBody">
                  {sexing == 'yes' ? (
                    <>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.todayMale')}</div>
                          {batchWeights.chickWeight_male_status ? (
                            <div className="statValue">{batchWeights.chickWeight_male}<span className="unit">Kg</span></div>
                          ) : <span className="notEntered">{t('common:state.notEntered')}</span>}
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.forecastMale')} {measuredInfo(forecast.weight_male, 'wm')}</div>
                          <div className="statValue predicted">
                            {valOrNA(forecast.weight_male.predicted_final, 3, forecast.weight_male.reason)}
                            {forecast.weight_male.predicted_final != null ? <span className="unit">Kg</span> : null}
                          </div>
                        </div>
                      </div>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.todayFemale')}</div>
                          {batchWeights.chickWeight_female_status ? (
                            <div className="statValue">{batchWeights.chickWeight_female}<span className="unit">Kg</span></div>
                          ) : <span className="notEntered">{t('common:state.notEntered')}</span>}
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.forecastFemale')} {measuredInfo(forecast.weight_female, 'wf')}</div>
                          <div className="statValue predicted">
                            {valOrNA(forecast.weight_female.predicted_final, 3, forecast.weight_female.reason)}
                            {forecast.weight_female.predicted_final != null ? <span className="unit">Kg</span> : null}
                          </div>
                        </div>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:labels.lastRecordedMale')}</span>
                        <span style={{ textAlign: 'right' }}>
                          <span className="breakdownVal">
                            {batchWeights.lastUpdatedWeight_male == '' || batchWeights.lastUpdatedWeight_male == undefined ? 0 : batchWeights.lastUpdatedWeight_male} Kg
                          </span>
                          {batchWeights.lastUpdatedWeightDate ? (
                            <span className="breakdownDate">{batchWeights.lastUpdatedWeightDate}</span>
                          ) : null}
                        </span>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:labels.lastRecordedFemale')}</span>
                        <span style={{ textAlign: 'right' }}>
                          <span className="breakdownVal">
                            {batchWeights.lastUpdatedWeight_female == '' || batchWeights.lastUpdatedWeight_female == undefined ? 0 : batchWeights.lastUpdatedWeight_female} Kg
                          </span>
                          {batchWeights.lastUpdatedWeightDate ? (
                            <span className="breakdownDate">{batchWeights.lastUpdatedWeightDate}</span>
                          ) : null}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.today')}</div>
                          {batchWeights.weightStatus ? (
                            <div className="statValue">{batchWeights.weight}<span className="unit">Kg</span></div>
                          ) : <span className="notEntered">{t('common:state.notEntered')}</span>}
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:labels.forecastWeight')} {measuredInfo(forecast.weight, 'w')}</div>
                          <div className="statValue predicted">
                            {valOrNA(forecast.weight.predicted_final, 3, forecast.weight.reason)}
                            {forecast.weight.predicted_final != null ? <span className="unit">Kg</span> : null}
                          </div>
                        </div>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:labels.lastRecorded')}</span>
                        <span style={{ textAlign: 'right' }}>
                          <span className="breakdownVal">
                            {batchWeights.lastUpdatedWeight == '' || batchWeights.lastUpdatedWeight == undefined ? 0 : batchWeights.lastUpdatedWeight} Kg
                          </span>
                          {batchWeights.lastUpdatedWeightDate ? (
                            <span className="breakdownDate">{batchWeights.lastUpdatedWeightDate}</span>
                          ) : null}
                        </span>
                      </div>
                    </>
                  )}
                  {(forecast.weight.harvest_day >= 35 || forecast.weight_male.harvest_day >= 35 || forecast.weight_female.harvest_day >= 35) && (
                    <div className="tileFootnote" title={t('dashboard:fcr.capNote', { day: 35 })}>
                      {t('dashboard:fcr.capNoteShort', { day: 35 })}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/feedratio.png" alt="" onError={(e) => { e.target.style.display = 'none'; }} />
                  <span>{t('common:metrics.fcr')}</span>
                  <span className={`statusDotMini status-${forecastStatusMap[forecast.fcr.status]?.cls || 'na'}`} title={forecastStatusMap[forecast.fcr.status]?.label || t('dashboard:empty.noForecast')}></span>
                  <button type="button" className="forecastIconBtn" title={t('dashboard:fcr.viewForecastChart')} onClick={() => setForecastModalKind('fcr')}>
                    <MaterialIcon icon="show_chart" color="#292970" size={18} />
                  </button>
                </div>
                <div className="tileBody">
                  {sexing == 'yes' ? (
                    <>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.currentMale')}</div>
                          <div className="statValue">{valOrNA(forecast.fcr_male.current_fcr, 2, forecast.fcr_male.reason)}</div>
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.forecastMale')} {measuredInfo(forecast.fcr_male, 'fm')}</div>
                          <div className="statValue predicted">{valOrNA(forecast.fcr_male.predicted_final, 2, forecast.fcr_male.reason)}</div>
                        </div>
                      </div>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.currentFemale')}</div>
                          <div className="statValue">{valOrNA(forecast.fcr_female.current_fcr, 2, forecast.fcr_female.reason)}</div>
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.forecastFemale')} {measuredInfo(forecast.fcr_female, 'ff')}</div>
                          <div className="statValue predicted">{valOrNA(forecast.fcr_female.predicted_final, 2, forecast.fcr_female.reason)}</div>
                        </div>
                      </div>
                      <div className="statRow">
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.currentHatched')}</div>
                          <div className="statValue">{valOrNA(forecast.fcr_hatched.current_fcr, 2, forecast.fcr_hatched.reason)}</div>
                        </div>
                        <div className="statBlock">
                          <div className="statLabel">{t('dashboard:fcr.forecastHatched')} {measuredInfo(forecast.fcr_hatched, 'fh')}</div>
                          <div className="statValue predicted">{valOrNA(forecast.fcr_hatched.predicted_final, 2, forecast.fcr_hatched.reason)}</div>
                        </div>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:fcr.idealTodayMale')}</span>
                        <span className="breakdownVal">{valOrNA(forecast.fcr_male.ideal_today, 2, forecast.fcr_male.reason)}</span>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:fcr.idealTodayFemale')}</span>
                        <span className="breakdownVal">{valOrNA(forecast.fcr_female.ideal_today, 2, forecast.fcr_female.reason)}</span>
                      </div>
                      <div className="breakdownRow">
                        <span className="breakdownLabel">{t('dashboard:fcr.idealTodayHatched')}</span>
                        <span className="breakdownVal">{valOrNA(forecast.fcr_hatched.ideal_today, 2, forecast.fcr_hatched.reason)}</span>
                      </div>
                    </>
                  ) : (
                    <div className="statRow">
                      <div className="statBlock">
                        <div className="statLabel">{t('dashboard:fcr.current')}</div>
                        <div className="statValue">{valOrNA(forecast.fcr.current_fcr, 2, forecast.fcr.reason)}</div>
                      </div>
                      <div className="statBlock">
                        <div className="statLabel">{t('dashboard:fcr.forecastFcr')} {measuredInfo(forecast.fcr, 'f')}</div>
                        <div className="statValue predicted">{valOrNA(forecast.fcr.predicted_final, 2, forecast.fcr.reason)}</div>
                      </div>
                    </div>
                  )}
                  {(forecast.fcr.harvest_day >= 35 || forecast.fcr_male.harvest_day >= 35 || forecast.fcr_female.harvest_day >= 35) && (
                    <div className="tileFootnote" title={t('dashboard:fcr.capNote', { day: 35 })}>
                      {t('dashboard:fcr.capNoteShort', { day: 35 })}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/feed.png" alt="" />
                  <span>{t('common:metrics.feed')}</span>
                  {/* Entry status, NOT performance. The Weight and FCR dots
                      beside this one mean ahead/on-track/behind; this one
                      only says whether today's feed has been recorded, which
                      is why it carries its own title text. */}
                  <span className={`statusDotMini status-${batchWeights.feedStatus ? 'entered' : 'missing'}`}
                        title={batchWeights.feedStatus
                          ? t('dashboard:feed.enteredToday')
                          : t('dashboard:feed.notEnteredToday')}></span>
                  <button type="button" className="forecastIconBtn"
                          title={t('dashboard:feed.viewAnalysis')}
                          onClick={() => setFeedAnalysisOpen(true)}>
                    <MaterialIcon icon="bar_chart" color="#292970" size={18} />
                  </button>
                </div>
                <div className="tileBody">
                  <div className="statRow">
                    <div className="statBlock">
                      <div className="statLabel">{t('dashboard:labels.batchTotal')}</div>
                      <div className="statValue">{isNaN(batchWeights.feed) ? 0 : batchWeights.feed.toLocaleString()}<span className="unit">Kg</span></div>
                    </div>
                    <div className="statBlock">
                      <div className="statLabel">{t('dashboard:labels.today')}</div>
                      {batchWeights.feedStatus ? (
                        <div className="statValue">{isNaN(batchWeights.feedToday) ? 0 : batchWeights.feedToday.toLocaleString()}<span className="unit">Kg</span></div>
                      ) : <span className="notEntered">{t('common:state.notEntered')}</span>}
                    </div>
                  </div>
                  <div className="breakdownRow">
                    <span className="breakdownLabel">{t('dashboard:labels.perBirdBatch')}</span>
                    <span className="breakdownVal">
                      {batchWeights.perBird_batch === '' || batchWeights.perBird_batch === undefined || isNaN(batchWeights.perBird_batch)
                        ? 0
                        : batchWeights.perBird_batch.toLocaleString()} Kg
                    </span>
                  </div>
                  <div className="breakdownRow">
                    <span className="breakdownLabel">{t('dashboard:labels.perBirdToday')}</span>
                    <span className="breakdownVal">
                      {batchWeights.perBird_today === '' || batchWeights.perBird_today === undefined || isNaN(batchWeights.perBird_today)
                        ? 0
                        : batchWeights.perBird_today.toLocaleString()} Kg
                    </span>
                  </div>
                  {batchWeights.lastFeedDate ? (
                    <div className="breakdownRow">
                      <span className="breakdownLabel">{t('dashboard:labels.lastRecorded')}</span>
                      <span style={{ textAlign: 'right' }}>
                        <span className="breakdownVal">
                          {batchWeights.lastFeedDay != null ? `${t('common:time.day')} ${batchWeights.lastFeedDay}` : ''}
                        </span>
                        <span className="breakdownDate">{batchWeights.lastFeedDate}</span>
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {/* Tile Grid — row 2: Water Consumption | Exhaust Fans */}
          <div className="row tileGrid">
            <div className="col-md-6">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/waterdrops.png" alt="" />
                  <span>{t('common:metrics.waterConsumption')}</span>
                </div>
                <div className="tileBody">
                  {
                    watermeter() == 0 ?
                      <div className="waterMeterMessage" style={{ marginTop: 0, marginBottom: 8 }} role="alert">
                        <img src="/dist/img/lock.png" width={20}></img> {t('dashboard:pro.short')}
                      </div>
                      : ''
                  }
                  <div className="statRow">
                    <div className="statBlock">
                      <div className="statLabel">{t('dashboard:labels.batchTotal')}</div>
                      <div className="statValue">{waterConsumptiomn.total}<span className="unit">L</span></div>
                    </div>
                    <div className="statBlock">
                      <div className="statLabel">{t('dashboard:labels.today')}</div>
                      <div className="statValue">{waterConsumptiomn.today}<span className="unit">L</span></div>
                    </div>
                    <div className="statBlock">
                      <div className="statLabel">{t('dashboard:labels.lastHour')}</div>
                      <div className="statValue">{waterConsumptiomn.lastHr}<span className="unit">L</span></div>
                    </div>
                  </div>
                  <div className="breakdownRow">
                    <span className="breakdownLabel">{t('dashboard:labels.perBirdBatch')}</span>
                    <span className="breakdownVal">{waterConsumptiomn.perBird_total === 0 ? 'NA' : waterConsumptiomn.perBird_total}</span>
                  </div>
                  <div className="breakdownRow">
                    <span className="breakdownLabel">{t('dashboard:labels.perBirdToday')}</span>
                    <span className="breakdownVal">{waterConsumptiomn.perBird_today === 0 ? 'NA' : waterConsumptiomn.perBird_today}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="tile">
                <div className="tileHeader">
                  <img src="/dist/img/fan.png" alt="" />
                  <span>{t('dashboard:panel.exhaustFans')}</span>
                  {controls() == 1 ? (
                    <NavLink
                      exact
                      to={{ pathname: "/managefans", farmID: selectedFarm }}
                      className="tileAction"
                    >
                      {t('dashboard:panel.manage')}
                    </NavLink>
                  ) : (
                    <span className="tileAction disabled">{t('dashboard:panel.manage')}</span>
                  )}
                </div>
                <div className="tileBody">
                  {
                    controls() == 0 ?
                      <div className="waterMeterMessage" role="alert">
                        <img src="/dist/img/lock.png" width={30}></img>
                        {t('dashboard:pro.long')}
                      </div>
                      : ''
                  }
                  {
                    controls() == 1 && fanInfo.length === 0 ?
                      <div className="noDataState">
                        <MaterialIcon icon="mode_fan_off" color="#c5c8df" size={56} />
                        <div className="noDataText">{t('dashboard:empty.noFanInfo')}</div>
                      </div>
                      : ''
                  }
                  <ul className="fans">
                    {fanInfo.map((item, index) => (
                      <li>
                        {item.swtichStatus === 'ACTIVE' ?
                          <img className='rotating' src="/dist/img/fan.png"></img>
                          : <img src="/dist/img/fan_grey.png"></img>}
                        <div className="fan-number">{t('dashboard:panel.fan')} {index + 1} {item.switchStatus}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
    </>
  );

  return (
    <div className="dashboard">
      <div className="dashboardHeader">
        <div className="hdrSelectors">
          {role == Role.Admin ? (
            <div className="hdrField">
              <label>{t('common:entity.farmer')}</label>
              <select
                style={{ width: "100%" }} id="selectFarmer"
                className="form-control form-control-sm">
                {farmerData.map(item => (
                  <option key={item.id} value={item.id}>{item.farmerName}</option>
                ))}
              </select>
            </div>
          ) : null}
          <div className="hdrField">
            <label>{t('common:entity.barn')}</label>
            <select onChange={(e) => onChangeHandler(e.target.value)}
              style={{ width: "100%" }} id="selectFarm"
              className="form-control form-control-sm">
              {farmData.map(item => (
                <option key={item.farmID} value={item.farmID}>{item.farmName}</option>
              ))}
            </select>
          </div>
          <div className="hdrLoader">
            {showLoader ? (
              <section {...containerProps}>{indicatorEl}</section>
            ) : null}
          </div>
        </div>

        <div className="hdrStatus">
          {/* Clicking through to Batch Operations for THIS batch saves re-picking
              farmer -> farm -> batch by hand on the other screen. Only a real,
              identified batch is clickable: with nothing selected the chip stays
              inert rather than navigating to an empty page. */}
          {batchWeights.batchID && selectedFarm ? (
            <button
              type="button"
              className="hdrChip hdrChipLink"
              title={t('dashboard:status.openBatchOperations')}
              onClick={() => history.push('/batchOperations', {
                batchID: batchWeights.batchID,
                farmID: selectedFarm,
                farmerID: selectedFarmer,
                batchName: batchWeights.batchName,
              })}
            >
              <span className="chipKey">{t('common:entity.batch')}</span>
              {batchWeights.batchName ? batchWeights.batchName : 'N/A'}
              <i className="fas fa-arrow-right hdrChipArrow" aria-hidden="true" />
            </button>
          ) : (
            <span className="hdrChip">
              <span className="chipKey">{t('common:entity.batch')}</span>
              {batchWeights.batchName ? batchWeights.batchName : 'N/A'}
            </span>
          )}
          <span className="hdrChip">
            <span className="chipKey">{t('common:entity.breed')}</span>
            {breedName || 'N/A'}
          </span>
          <span className="hdrChip">
            <span className="chipKey">{t('common:time.day')}</span>
            {currentDay || 'N/A'}
          </span>
          <span className="hdrChip">
            <span className="chipKey">{t('common:time.phase')}</span>
            {phaseNumber || 'N/A'}
          </span>
          {batchStatus ? <span className="hdrChip danger">{batchStatus}</span> : null}
        </div>

        <div className="hdrMeta">
          <span className={`signalPill ${signalStatus}`}>
            <i className="fa fa-wifi" aria-hidden="true"></i>
            -{signalStrength} dBm
          </span>
          <span className="updateMeta">
            <b>{t('dashboard:status.updated')}</b> {lastUpdated && lastUpdated !== 'Invalid date' ? lastUpdated : '—'}
          </span>
        </div>
      </div>
      <section className="tabsArea">
        {showTabs ? (
          <Tabs activeHeaderStyle={{ background: 'transparent' }}>
            {/* Children are passed as ONE FILTERED ARRAY, not as sibling
                conditionals. react-bootstrap-tabs maps this.props.children
                straight to header <li>s with no falsy check (dist/index.js:155),
                so a `: <></>` branch renders a real, blank, clickable tab -- and
                clicking it reads .props.label off a fragment. Filtering before
                the library sees the list is the only way to omit a tab. */}
            {[
              <Tab key="barn" label={t('dashboard:panel.barnMonitor')}>{barnMonitorPanel}</Tab>,
              SHOW_TRENDS_TAB && (
                <Tab key="trends" label={t('dashboard:panel.todaysTrends')}>
                  <div className="trendsArea">
                    <div className="row tileGrid">
                      <div className="col-lg-6">
                        <div className="tile trendTile">
                          <div className="tileHeader">
                            <img src="/dist/img/celsius.png" alt="" />
                            <span>{t('common:sensors.temperature')}</span>
                            <div className="trendStats">
                              <span className="trendChip current"><span className="ck">{t('common:sensors.now')}</span>{currValues.temp} °C</span>
                              <span className="trendChip min"><span className="ck">{t('common:metrics.min')}</span>{dashboardValues.mintemp} °C</span>
                              <span className="trendChip max"><span className="ck">{t('common:metrics.max')}</span>{dashboardValues.maxtemp} °C</span>
                            </div>
                          </div>
                          <div className="tileBody">
                            {Array.isArray(tempState) && tempState.length > 0 ? (
                              <EchartLine data={tempState} xaxis={xData} maxVal='50' color='#4f46e5' interval={5}
                                max={thresholds.tempMax} min={thresholds.tempMin}></EchartLine>
                            ) : emptyChartState}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="tile trendTile">
                          <div className="tileHeader">
                            <img src="/dist/img/humidity.png" alt="" />
                            <span>{t('common:sensors.humidity')}</span>
                            <div className="trendStats">
                              <span className="trendChip current"><span className="ck">{t('common:sensors.now')}</span>{currValues.rh}%</span>
                              <span className="trendChip min"><span className="ck">{t('common:metrics.min')}</span>{dashboardValues.minrh}%</span>
                              <span className="trendChip max"><span className="ck">{t('common:metrics.max')}</span>{dashboardValues.maxrh}%</span>
                            </div>
                          </div>
                          <div className="tileBody">
                            {Array.isArray(rhState) && rhState.length > 0 ? (
                              <EchartLine data={rhState} xaxis={xData} maxVal='110' color='#4f46e5'
                                interval={10} max={thresholds.rhMax} min={thresholds.rhMin}></EchartLine>
                            ) : emptyChartState}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="tile trendTile">
                          <div className="tileHeader">
                            <img src="/dist/img/co2-cloud.png" alt="" />
                            <span>{t('common:sensors.co2')}</span>
                            <div className="trendStats">
                              <span className="trendChip current"><span className="ck">{t('common:sensors.now')}</span>{currValues.co}</span>
                              <span className="trendChip min"><span className="ck">{t('common:metrics.min')}</span>{dashboardValues.minco}</span>
                              <span className="trendChip max"><span className="ck">{t('common:metrics.max')}</span>{dashboardValues.maxco}</span>
                            </div>
                          </div>
                          <div className="tileBody">
                            {Array.isArray(coState) && coState.length > 0 ? (
                              <EchartLine data={coState} xaxis={xData}
                                maxVal={3500} color='#4f46e5' interval={500}
                                max={thresholds.coMax} min='null'></EchartLine>
                            ) : emptyChartState}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="tile trendTile">
                          <div className="tileHeader">
                            <img src="/dist/img/ammonia.png" alt="" />
                            <span>{t('common:sensors.ammonia')}</span>
                            <div className="trendStats">
                              <span className="trendChip current"><span className="ck">{t('common:sensors.now')}</span>{currValues.nh}</span>
                              <span className="trendChip min"><span className="ck">{t('common:metrics.min')}</span>{dashboardValues.minnh}</span>
                              <span className="trendChip max"><span className="ck">{t('common:metrics.max')}</span>{dashboardValues.maxnh}</span>
                            </div>
                          </div>
                          <div className="tileBody">
                            {Array.isArray(nhState) && nhState.length > 0 ? (
                              <EchartLine data={nhState} xaxis={xData}
                                maxVal={30} color='#4f46e5' interval={5} max={thresholds.nhMax} min='null'></EchartLine>
                            ) : emptyChartState}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              ),
              role == Role.Admin && (
                <Tab key="devices" label={t('dashboard:panel.deviceConnections')}>
                  <DeviceConnections></DeviceConnections>
                </Tab>
              ),
            ].filter(Boolean)}
          </Tabs>
        ) : barnMonitorPanel}
      </section>

      <MortalityModal
        show={mortalityOpen}
        onClose={closeMortality}
        sexing={sexing}
        batchWeights={batchWeights}
        submit={submitDailyEntry}
      />
      <WeightModal
        show={weightOpen}
        onClose={closeWeight}
        sexing={sexing}
        batchWeights={batchWeights}
        submit={submitDailyEntry}
      />
      <FeedModal
        show={feedOpen}
        onClose={closeFeed}
        batchWeights={batchWeights}
        submit={submitDailyEntry}
      />
      <ForecastDetailModal
        show={forecastModalKind !== null}
        onClose={() => setForecastModalKind(null)}
        kind={forecastModalKind}
        sexing={sexing}
        data={forecastModalKind === 'fcr' ? forecast.fcr : forecast.weight}
        dataMale={forecastModalKind === 'fcr' ? forecast.fcr_male : forecast.weight_male}
        dataFemale={forecastModalKind === 'fcr' ? forecast.fcr_female : forecast.weight_female}
        dataHatched={forecastModalKind === 'fcr' ? forecast.fcr_hatched : null}
        weightData={forecast.weight}
        weightDataMale={forecast.weight_male}
        weightDataFemale={forecast.weight_female}
        liveBirds={batchWeights?.numberofLiveBirds}
        day={currentDay}
        duration={duration}
        chip={forecastChip}
        valOrNA={valOrNA}
        fmtDelta={fmtDelta}
      />
      <FeedAnalysisModal
        show={feedAnalysisOpen}
        onClose={() => setFeedAnalysisOpen(false)}
        farmID={selectedFarm}
        sexing={sexing}
      />
      <SensorTrendModal
        show={sensorModalKey !== null}
        onClose={() => setSensorModalKey(null)}
        sensor={activeSensor}
        status={activeSensor ? activeSensor.status : 'idle'}
        values={activeSensor ? activeSensor.series : []}
        xLabels={xData}
        timestamps={sensorTimes}
        now={activeSensor ? activeSensor.value : null}
        dayMin={activeSensor ? activeSensor.dayMin : null}
        dayMax={activeSensor ? activeSensor.dayMax : null}
        dayAvg={activeSensor ? activeSensor.dayAvg : null}
        lo={activeSensor ? activeSensor.lo : null}
        hi={activeSensor ? activeSensor.hi : null}
        lastUpdated={lastUpdated}
      />
    </div>
  );
};

// ===== Forecast Detail Modal (chart drawer) =====

function ForecastDetailModal({ show, onClose, kind, sexing, data, dataMale, dataFemale, dataHatched, weightData, weightDataMale, weightDataFemale, liveBirds, day, duration, chip, valOrNA, fmtDelta }) {
  const { t, i18n } = useTranslation(['dashboard', 'common']);
  const [activeTab, setActiveTab] = useState('male'); // 'male' | 'female'
  // ECharts measures its container on mount. Mounted while the modal is still
  // animating (or display:none) it reads the wrong width/height, and the canvas
  // is then CSS-stretched to the final box — blurry text, distorted plot. Wait
  // for onEntered, when the dialog has its final dimensions.
  const [entered, setEntered] = useState(false);
  useEffect(() => { if (show) setActiveTab('male'); }, [show]);

  if (!kind) return null;
  const isWeight = kind === 'weight';
  const isFcr = kind === 'fcr';
  const sexed = sexing === 'yes';
  const title = isWeight ? 'Weight Forecast' : 'FCR Forecast';
  const unit = isWeight ? 'kg' : '';
  const decimals = isWeight ? 3 : 2;
  const inverseDelta = isFcr;

  const active = sexed
    ? (activeTab === 'female' ? dataFemale : activeTab === 'hatched' ? dataHatched : dataMale)
    : data;
  // Weight block matching the active tab — the insights need it to turn an FCR
  // into a feed quantity. 'hatched' has no weight forecast of its own.
  const activeWeight = sexed
    ? (activeTab === 'female' ? weightDataFemale : activeTab === 'hatched' ? null : weightDataMale)
    : weightData;
  // Live-bird count is only reliable for the whole flock: a sexed batch has no
  // per-sex live count passed in, so the feed-volume insights are skipped there
  // rather than shown against the wrong denominator.
  const insightBirds = sexed ? null : liveBirds;
  const i18nNum = (v, dp) => {
    const nn = Number(v);
    if (!Number.isFinite(nn)) return '—';
    try {
      return new Intl.NumberFormat(i18n.language || 'en', {
        minimumFractionDigits: dp, maximumFractionDigits: dp,
      }).format(nn);
    } catch (e) { return nn.toFixed(dp); }
  };

  const status = active?.status || 'NA';
  const isNA = status === 'NA';
  const reasonText = active?.reason || 'No forecast data is available yet.';

  // "Fallback" = there's no record for today, so today_actual/current_fcr actually
  // holds the LAST recorded measurement (taken on measured_on_day). Detect it from
  // the explicit flag, or when the measured day differs from the current day.
  const isFallback = !!active?.is_fallback
    || (active?.measured_on_day != null && Number(active.measured_on_day) !== Number(day));
  const measuredDate = active?.measured_on_date || '';
  const currentLabel = isWeight
    ? (isFallback ? 'Last Recorded Weight' : "Today's Weight")
    : (isFallback ? 'Last Recorded FCR' : 'Current FCR');
  const currentVal = isWeight ? active?.today_actual : active?.current_fcr;
  const idealVal = isWeight ? active?.today_ideal : active?.ideal_today;
  const finalVal = active?.predicted_final;

  const rawDays = Array.isArray(active?.chart?.days) ? active.chart.days : [];
  // Label the x-axis by index (0..N-1) so it always starts at Day 0, regardless
  // of whether the forecast API sends 0- or 1-based day numbers.
  const chartDays = rawDays.map((_, i) => i);
  const chartPredicted = Array.isArray(active?.chart?.predicted)
    ? active.chart.predicted
    : (Array.isArray(active?.chart?.actual) ? active.chart.actual : []);
  const chartIdeal = Array.isArray(active?.chart?.ideal) ? active.chart.ideal : [];
  const hasChart = chartDays.length > 0 && (chartPredicted.length > 0 || chartIdeal.length > 0);
  // Anchor "current" to the last measured day on a fallback (e.g. a long-closed
  // batch whose currentDay is far past the curve) so we don't show a nonsensical
  // day number. Locate it by position — base-agnostic to the API's day numbering.
  const anchorDay = isFallback && active?.measured_on_day != null ? active.measured_on_day : day;
  const todayPos = rawDays.findIndex((d) => Number(d) === Number(anchorDay));
  // Last day index is the 0-based duration; the harvest gap is shift-invariant.
  const effDuration = chartDays.length ? chartDays[chartDays.length - 1] : 0;
  // If the anchor isn't on the curve, clamp to the last day rather than echoing a
  // raw out-of-range value (which produced "Day 332 of 35").
  const todayIdx = todayPos >= 0 ? todayPos : effDuration;
  const daysLeft = effDuration - todayIdx;

  const Tab = ({ value, label }) => (
    <button
      type="button"
      className={`sexTab ${activeTab === value ? 'active' : ''}`}
      onClick={() => setActiveTab(value)}>
      {label}
    </button>
  );

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
      dialogClassName="forecastModalWide"
      onEntered={() => setEntered(true)}
      onExited={() => setEntered(false)}
    >
      <Modal.Header>
        <div className="forecastModalHeader">
          <Modal.Title>{title}</Modal.Title>
          {chip(status)}
        </div>
        <button type="button" className="modalCloseBtn" onClick={onClose} aria-label={t('common:actions.close')}>×</button>
      </Modal.Header>
      <Modal.Body>
        {effDuration > 0 && (
          <div className="forecastSubtitle">
            {t('common:time.day')} {t('dashboard:labels.dayOfHarvest', { day: todayIdx, total: effDuration, left: Math.max(daysLeft, 0) })}
            {active?.standard?.breed && (
              <span className="forecastBreedTag">
                {active.standard.breed}
                {active.standard.year ? ` · ${active.standard.year}` : ''}
                {active.standard.sex ? ` · ${t('dashboard:fcr.sex.' + active.standard.sex, { defaultValue: active.standard.sex })}` : ''}
              </span>
            )}
          </div>
        )}
        {effDuration >= 35 && (
          <div className="forecastCapNote">
            <MaterialIcon icon="info" color="#6b6bb8" size={14} />
            <span>{t('dashboard:fcr.capNote', { day: effDuration })}</span>
          </div>
        )}
        {sexed && (
          <div className="sexTabs" title={isFcr ? 'Per-sex FCR assumes a 50/50 feed split' : undefined}>
            <Tab value="male" label={t('common:gender.male')} />
            <Tab value="female" label={t('common:gender.female')} />
            {isFcr && dataHatched && <Tab value="hatched" label={t('dashboard:labels.hatched')} />}
            {isFcr && <span className="sexTabsHint">{t('dashboard:fcr.perSexNote')}</span>}
          </div>
        )}
        {isNA ? (
          <div className="noDataState">
            <MaterialIcon icon="radio_button_unchecked" color="#9CA3AF" size={56} />
            <div className="noDataText">{t('dashboard:empty.noForecastAvailable')}</div>
            <div className="noDataHint">{reasonText}</div>
          </div>
        ) : (
          <>
            <div className="forecastGrid">
              <div className="forecastMain">
                <div className="kpiRow">
                  <div className="kpiCard">
                    <div className="kpiLabel">{currentLabel}</div>
                    <div className="kpiValue">{valOrNA(currentVal, decimals, reasonText)}{currentVal != null && unit ? <span className="unit">{unit}</span> : null}</div>
                    <div className="kpiFoot">{fmtDelta(currentVal, idealVal, decimals, inverseDelta)}</div>
                    {isFallback && currentVal != null && (
                      <div className="kpiSub">{t('dashboard:labels.asOfDay', { day: todayIdx })}{measuredDate ? ` \u00b7 ${measuredDate}` : ''}</div>
                    )}
                  </div>
                  <div className="kpiCard">
                    <div className="kpiLabel">{isFallback ? t('dashboard:labels.idealAtDay', { day: todayIdx }) : t('dashboard:labels.idealForToday')}</div>
                    <div className="kpiValue">{valOrNA(idealVal, decimals, reasonText)}{idealVal != null && unit ? <span className="unit">{unit}</span> : null}</div>
                    {isFcr && active?.standard_fcr_today != null && (
                      <div className="kpiSub">{t('dashboard:fcr.tableValue', { value: i18nNum(active.standard_fcr_today, 2) })}</div>
                    )}
                  </div>
                  <div className="kpiCard kpiCardAccent">
                    <div className="kpiLabel">{t('dashboard:fcr.forecastAtHarvest')}</div>
                    <div className="kpiValue kpiValueAccent">{valOrNA(finalVal, decimals, reasonText)}{finalVal != null && unit ? <span className="unit">{unit}</span> : null}</div>
                    {isFcr && active?.standard_fcr_final != null && (
                      <div className="kpiFoot kpiFootMuted" title={t('dashboard:fcr.benchmarkTitle', { breed: active?.standard?.breed || '' })}>
                        {t('dashboard:fcr.vsBreedStandard', { value: i18nNum(active.standard_fcr_final, 2) })}
                      </div>
                    )}
                  </div>
                </div>
                {hasChart ? (
                  <div className="forecastChartBig">
                    {entered ? (
                    <ProjectionMiniChart
                      days={chartDays}
                      predicted={chartPredicted}
                      ideal={chartIdeal}
                      today={todayIdx}
                      todayLabel={isFallback ? t('dashboard:labels.lastRecordedLower') : t('dashboard:labels.today')}
                      color={statusColor(status)}
                      yInterval={isWeight ? 0.5 : 0.25}
                      unitSuffix={unit ? ' ' + unit : ''}
                      decimals={decimals}
                      splitAt={todayIdx}
                      lowerIsBetter={isFcr}
                      trimStart={isFcr ? 5 : 0}
                      height={440}
                    />
                    ) : (
                      <div className="chartMountPlaceholder" style={{ height: 440 }} />
                    )}
                    {isFcr && <div className="chartFooterNote">{t('dashboard:fcr.lowerIsBetter')}</div>}
                  </div>
                ) : (
                  <div className="projectionChartEmpty">
                    <MaterialIcon icon="show_chart" color="#c5c8df" size={48} />
                    <span>{t('dashboard:empty.forecastCurvePlaceholder')}</span>
                  </div>
                )}
              </div>
              <aside className="forecastSide">
                <div className="sideHeading">{t('dashboard:fcr.whatThisMeans')}</div>
                {isFcr ? (
                  <ForecastInsights
                    t={t}
                    data={active}
                    weightData={activeWeight}
                    liveBirds={insightBirds}
                    i18nNum={i18nNum}
                  />
                ) : (
                  <WeightInsights
                    t={t}
                    data={active}
                    liveBirds={insightBirds}
                    i18nNum={i18nNum}
                  />
                )}
              </aside>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="modalCancelBtn" onClick={onClose}>{t('common:actions.close')}</button>
      </Modal.Footer>
    </Modal>
  );
}


// ===== Forecast Insights =====

// Turns the forecast block into plain statements a farm manager can act on.
//
// The one that matters most is the mortality split. `farm_fcr` and
// `biological_fcr` differ ONLY by feed eaten by birds that later died, so
// separating them answers a question a single FCR number cannot: is this flock
// converting badly, or did it lose birds? Those are two completely different
// problems with two completely different responses.
//
// Feed volumes are derived from the forecast itself rather than re-fetched, so
// they can never disagree with the numbers displayed beside them:
//   feed = FCR x liveBirds x weight     (both FCRs here are standing-biomass)
function ForecastInsights({ t, data, weightData, liveBirds, i18nNum }) {
  if (!data || data.status === 'NA') return null;

  const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : null);
  const bio = num(data.biological_fcr) ?? num(data.current_fcr);
  const stdToday = num(data.standard_fcr_today);
  const penalty = num(data.mortality_penalty);
  const feedLost = num(data.feed_lost_to_mortality);
  const birds = num(liveBirds);
  const wNow = num(weightData && weightData.today_actual);
  const wEnd = num(weightData && weightData.predicted_final);
  const fcrNow = num(data.current_fcr);
  const fcrEnd = num(data.predicted_final);

  // kg -> "1.8 t" above a tonne, "840 kg" below. Farmers order feed in both.
  const mass = (kg) => {
    if (!Number.isFinite(kg)) return null;
    return kg >= 1000
      ? t('dashboard:fcr.insights.tonnes', { value: i18nNum(kg / 1000, 1) })
      : t('dashboard:fcr.insights.kilos', { value: i18nNum(Math.round(kg), 0) });
  };

  const cards = [];

  // 1. Is this flock converting better or worse than its breed, at this age?
  //    Compared on biological FCR — the only one the breed table is defined on.
  if (bio != null && stdToday != null && stdToday > 0) {
    const gap = bio - stdToday;
    const pct = Math.abs(gap / stdToday) * 100;
    const onStandard = Math.abs(gap) < 0.02;
    cards.push({
      key: 'conversion',
      tone: onStandard ? 'neutral' : (gap < 0 ? 'good' : 'bad'),
      icon: onStandard ? 'trending_flat' : (gap < 0 ? 'trending_down' : 'trending_up'),
      title: onStandard
        ? t('dashboard:fcr.insights.onStandardTitle')
        : (gap < 0 ? t('dashboard:fcr.insights.betterTitle', { pct: i18nNum(pct, 1) })
                   : t('dashboard:fcr.insights.worseTitle', { pct: i18nNum(pct, 1) })),
      body: t('dashboard:fcr.insights.conversionBody', {
        bio: i18nNum(bio, 2),
        std: i18nNum(stdToday, 2),
        breed: (data.standard && data.standard.breed) || t('common:labels.breed'),
      }),
    });
  }

  // 2. The mortality split. Only shown when a daily log actually backed it and
  //    the penalty is big enough to round to something at 2dp.
  if (data.mortality_basis === 'daily-log' && penalty != null && penalty >= 0.005
      && fcrNow != null && bio != null) {
    cards.push({
      key: 'mortality',
      tone: 'info',
      icon: 'call_split',
      title: t('dashboard:fcr.insights.mortalitySplitTitle', { penalty: i18nNum(penalty, 2) }),
      body: t('dashboard:fcr.insights.mortalitySplitBody', {
        farm: i18nNum(fcrNow, 2),
        bio: i18nNum(bio, 2),
        penalty: i18nNum(penalty, 2),
        feed: mass(feedLost) || '—',
      }),
    });
  }

  // 3. How much feed is left to buy. Needs a bird count, so it is skipped on
  //    sexed batches where a reliable per-sex live count is not passed in.
  if (birds > 0 && wNow > 0 && wEnd > 0 && fcrNow != null && fcrEnd != null) {
    const feedSoFar = fcrNow * birds * wNow;
    const feedTotal = fcrEnd * birds * wEnd;
    const remaining = feedTotal - feedSoFar;
    if (Number.isFinite(remaining) && remaining > 0) {
      cards.push({
        key: 'feedleft',
        tone: 'info',
        icon: 'inventory_2',
        title: t('dashboard:fcr.insights.feedLeftTitle', { amount: mass(remaining) }),
        body: t('dashboard:fcr.insights.feedLeftBody', {
          day: data.harvest_day,
          total: mass(feedTotal),
        }),
      });
    }
  }

  // 4. What a step of 0.01 is worth, in feed. Makes an abstract ratio concrete.
  if (birds > 0 && wEnd > 0) {
    const per001 = 0.01 * birds * wEnd;
    cards.push({
      key: 'sensitivity',
      tone: 'neutral',
      icon: 'balance',
      title: t('dashboard:fcr.insights.sensitivityTitle', { amount: mass(per001) }),
      body: t('dashboard:fcr.insights.sensitivityBody'),
    });
  }

  return <InsightCards cards={cards} />;
}


// Weight-forecast insights — the growth-side counterparts of ForecastInsights.
//
// Everything is derived from the weight block itself (today/ideal/final and the
// chart arrays), so the cards can never disagree with the chart beside them.
// The schedule card inverts the ideal curve: find the day the STANDARD bird
// reaches the flock's current weight, and the difference from the actual age is
// "days ahead/behind schedule" — a more actionable number for a farm manager
// than a gram deficit.
function WeightInsights({ t, data, liveBirds, i18nNum }) {
  if (!data || data.status === 'NA') return null;

  const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : null);
  const actual = num(data.today_actual);
  const ideal = num(data.today_ideal);
  const fin = num(data.predicted_final);
  const days = (data.chart && data.chart.days) || [];
  const idealArr = (data.chart && data.chart.ideal) || [];
  const horizon = days.length ? Number(days[days.length - 1]) : null;
  const mDay = num(data.measured_on_day);
  const birds = num(liveBirds);
  const mass = (kg) => {
    if (!Number.isFinite(kg)) return null;
    return kg >= 1000
      ? t('dashboard:fcr.insights.tonnes', { value: i18nNum(kg / 1000, 1) })
      : t('dashboard:fcr.insights.kilos', { value: i18nNum(Math.round(kg), 0) });
  };

  const cards = [];

  // 1. Growth vs the breed curve, in percent — higher is better here.
  if (actual != null && ideal > 0) {
    const gap = actual - ideal;
    const pct = Math.abs(gap / ideal) * 100;
    const onCurve = pct < 2;
    cards.push({
      key: 'growth',
      tone: onCurve ? 'neutral' : (gap > 0 ? 'good' : 'bad'),
      icon: onCurve ? 'trending_flat' : (gap > 0 ? 'trending_up' : 'trending_down'),
      title: onCurve
        ? t('dashboard:weightInsights.onCurveTitle')
        : t(gap > 0 ? 'dashboard:weightInsights.aheadTitle' : 'dashboard:weightInsights.behindTitle',
            { pct: i18nNum(pct, 1) }),
      body: t('dashboard:weightInsights.growthBody', {
        actual: i18nNum(actual, 3), ideal: i18nNum(ideal, 3),
        day: mDay != null ? mDay : '',
      }),
    });
  }

  // 2. Days ahead/behind schedule — inverse lookup of the current weight on the
  //    ideal curve. Shown only when the gap rounds to at least half a day.
  if (actual != null && mDay != null && idealArr.length > 1) {
    let eqDay = null;
    for (let i = 0; i < idealArr.length - 1; i++) {
      const a = num(idealArr[i]);
      const b = num(idealArr[i + 1]);
      if (a == null || b == null) continue;
      if ((actual >= a && actual <= b) || (actual <= a && actual >= b)) {
        const frac = b === a ? 0 : (actual - a) / (b - a);
        eqDay = Number(days[i]) + frac * (Number(days[i + 1]) - Number(days[i]));
        break;
      }
    }
    if (eqDay != null) {
      // Standard bird reaches this weight at eqDay; flock is at mDay. Reaching
      // it EARLIER than the standard (eqDay > mDay) means running ahead.
      const diff = eqDay - mDay;
      if (Math.abs(diff) >= 0.5) {
        cards.push({
          key: 'schedule',
          tone: diff > 0 ? 'good' : 'bad',
          icon: 'schedule',
          title: t(diff > 0 ? 'dashboard:weightInsights.scheduleAheadTitle'
                           : 'dashboard:weightInsights.scheduleBehindTitle',
                   { days: i18nNum(Math.abs(diff), 1) }),
          body: t('dashboard:weightInsights.scheduleBody', {
            actual: i18nNum(actual, 2), eqDay: i18nNum(eqDay, 0),
          }),
        });
      }
    }
  }

  // 3. Total live weight at harvest. Needs a bird count, so it is skipped on
  //    sexed batches where a reliable per-sex live count is not passed in.
  if (birds > 0 && fin > 0 && horizon != null) {
    cards.push({
      key: 'biomass',
      tone: 'info',
      icon: 'monitor_weight',
      title: t('dashboard:weightInsights.biomassTitle', { amount: mass(birds * fin) }),
      body: t('dashboard:weightInsights.biomassBody', {
        birds: i18nNum(birds, 0), kg: i18nNum(fin, 2), day: horizon,
      }),
    });
  }

  // 4. Average daily gain from here to harvest, vs the standard over the same
  //    stretch — makes the trajectory concrete.
  if (actual != null && fin != null && mDay != null && horizon != null && horizon > mDay) {
    const gPerDay = ((fin - actual) * 1000) / (horizon - mDay);
    const idealFin = num(idealArr[idealArr.length - 1]);
    const stdPerDay = (ideal != null && idealFin != null)
      ? ((idealFin - ideal) * 1000) / (horizon - mDay)
      : null;
    if (Number.isFinite(gPerDay) && gPerDay > 0) {
      cards.push({
        key: 'adg',
        tone: 'neutral',
        icon: 'speed',
        title: t('dashboard:weightInsights.adgTitle', { g: i18nNum(gPerDay, 0) }),
        body: stdPerDay != null
          ? t('dashboard:weightInsights.adgBody', { std: i18nNum(stdPerDay, 0) })
          : '',
      });
    }
  }

  return <InsightCards cards={cards} />;
}



// ===== Daily Entry Modals =====

function MortalityModal({ show, onClose, sexing, batchWeights, submit }) {
  const { t } = useTranslation(['dashboard', 'common']);
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  useEffect(() => { if (show) reset(); }, [show, reset]);
  const onSubmit = async (data) => {
    const rows = sexing === 'yes'
      ? [
          { type: 'mortality_male',   value: data.mortality_male },
          { type: 'mortality_female', value: data.mortality_female },
          { type: 'culling_male',     value: data.culling_male },
          { type: 'culling_female',   value: data.culling_female },
        ]
      : [
          { type: 'mortality', value: data.mortality },
          { type: 'culling',   value: data.culling },
        ];
    const ok = await submit(rows);
    if (ok) onClose();
  };
  const intPattern = { value: /^[0-9]+$/, message: t('dashboard:entry.wholeNumbersOnly') };
  return (
    <Modal show={show} onHide={onClose} size="md" centered>
      <Modal.Header>
        <Modal.Title>{t('dashboard:entry.mortalityTitle')} {batchWeights.batchName || ''}</Modal.Title>
        <button type="button" className="modalCloseBtn" onClick={onClose} aria-label={t('common:actions.close')}>×</button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          {sexing === 'yes' ? (
            <>
              <div className="row">
                <div className="form-group col-md-6">
                  <label>{t('dashboard:entry.mortalityMale')}</label>
                  <input className="form-control"
                    defaultValue={batchWeights.mortality_male_status ? batchWeights.mortality_male : ''}
                    {...register('mortality_male', { pattern: intPattern })} />
                  {errors.mortality_male && <div className="errMsg">{errors.mortality_male.message}</div>}
                </div>
                <div className="form-group col-md-6">
                  <label>{t('dashboard:entry.mortalityFemale')}</label>
                  <input className="form-control"
                    defaultValue={batchWeights.mortality_female_status ? batchWeights.mortality_female : ''}
                    {...register('mortality_female', { pattern: intPattern })} />
                  {errors.mortality_female && <div className="errMsg">{errors.mortality_female.message}</div>}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-6">
                  <label>{t('dashboard:entry.cullingMale')}</label>
                  <input className="form-control"
                    defaultValue={batchWeights.culling_male_status ? batchWeights.culling_male : ''}
                    {...register('culling_male', { pattern: intPattern })} />
                  {errors.culling_male && <div className="errMsg">{errors.culling_male.message}</div>}
                </div>
                <div className="form-group col-md-6">
                  <label>{t('dashboard:entry.cullingFemale')}</label>
                  <input className="form-control"
                    defaultValue={batchWeights.culling_female_status ? batchWeights.culling_female : ''}
                    {...register('culling_female', { pattern: intPattern })} />
                  {errors.culling_female && <div className="errMsg">{errors.culling_female.message}</div>}
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="form-group col-md-6">
                <label>{t('common:metrics.mortality')}</label>
                <input className="form-control"
                  defaultValue={batchWeights.mortalityStatus ? batchWeights.mortality : ''}
                  {...register('mortality', { pattern: intPattern })} />
                {errors.mortality && <div className="errMsg">{errors.mortality.message}</div>}
              </div>
              <div className="form-group col-md-6">
                <label>{t('common:metrics.culling')}</label>
                <input className="form-control"
                  defaultValue={batchWeights.culling_status ? batchWeights.culling : ''}
                  {...register('culling', { pattern: intPattern })} />
                {errors.culling && <div className="errMsg">{errors.culling.message}</div>}
              </div>
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="modalCancelBtn" onClick={onClose}>{t('common:actions.cancel')}</button>
        <button type="button" className="modalSaveBtn" disabled={isSubmitting} onClick={handleSubmit(onSubmit)}>
          {isSubmitting ? 'Saving…' : 'Save'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function WeightModal({ show, onClose, sexing, batchWeights, submit }) {
  const { t } = useTranslation(['dashboard', 'common']);
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  useEffect(() => { if (show) reset(); }, [show, reset]);
  const onSubmit = async (data) => {
    const rows = sexing === 'yes'
      ? [
          { type: 'chick_male',   value: data.weight_male },
          { type: 'chick_female', value: data.weight_female },
        ]
      : [{ type: 'chick', value: data.weight }];
    const ok = await submit(rows);
    if (ok) onClose();
  };
  const weightPattern = { value: /^[0-5](\.\d+)?$/, message: '0–5 Kg only' };
  return (
    <Modal show={show} onHide={onClose} size="md" centered>
      <Modal.Header>
        <Modal.Title>{t('dashboard:entry.birdWeightTitle')} {batchWeights.batchName || ''}</Modal.Title>
        <button type="button" className="modalCloseBtn" onClick={onClose} aria-label={t('common:actions.close')}>×</button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          {sexing === 'yes' ? (
            <div className="row">
              <div className="form-group col-md-6">
                <label>{t('dashboard:entry.weightMaleKg')}</label>
                <input className="form-control"
                  defaultValue={batchWeights.chickWeight_male_status ? batchWeights.chickWeight_male : ''}
                  {...register('weight_male', { required: t('forms:requiredField.generic'), pattern: weightPattern })} />
                {errors.weight_male && <div className="errMsg">{errors.weight_male.message}</div>}
              </div>
              <div className="form-group col-md-6">
                <label>{t('dashboard:entry.weightFemaleKg')}</label>
                <input className="form-control"
                  defaultValue={batchWeights.chickWeight_female_status ? batchWeights.chickWeight_female : ''}
                  {...register('weight_female', { required: t('forms:requiredField.generic'), pattern: weightPattern })} />
                {errors.weight_female && <div className="errMsg">{errors.weight_female.message}</div>}
              </div>
            </div>
          ) : (
            <div className="form-group">
              <label>{t('dashboard:entry.weightKg')}</label>
              <input className="form-control"
                defaultValue={batchWeights.weightStatus ? batchWeights.weight : ''}
                {...register('weight', { required: t('forms:requiredField.generic'), pattern: weightPattern })} />
              {errors.weight && <div className="errMsg">{errors.weight.message}</div>}
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="modalCancelBtn" onClick={onClose}>{t('common:actions.cancel')}</button>
        <button type="button" className="modalSaveBtn" disabled={isSubmitting} onClick={handleSubmit(onSubmit)}>
          {isSubmitting ? 'Saving…' : 'Save'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function FeedModal({ show, onClose, batchWeights, submit }) {
  const { t } = useTranslation(['dashboard', 'common']);
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  useEffect(() => { if (show) reset(); }, [show, reset]);
  const onSubmit = async (data) => {
    const ok = await submit([{ type: 'feed', value: data.feed }]);
    if (ok) onClose();
  };
  const feedPattern = { value: /^\d+(\.\d{1,3})?$/, message: t('dashboard:entry.numberMax3Decimals') };
  return (
    <Modal show={show} onHide={onClose} size="md" centered>
      <Modal.Header>
        <Modal.Title>{t('dashboard:entry.feedTitle')} {batchWeights.batchName || ''}</Modal.Title>
        <button type="button" className="modalCloseBtn" onClick={onClose} aria-label={t('common:actions.close')}>×</button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label>{t('dashboard:entry.feedKg')}</label>
            <input className="form-control"
              defaultValue={batchWeights.feedStatus ? batchWeights.feedToday : ''}
              {...register('feed', { required: t('forms:requiredField.generic'), pattern: feedPattern })} />
            {errors.feed && <div className="errMsg">{errors.feed.message}</div>}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="modalCancelBtn" onClick={onClose}>{t('common:actions.cancel')}</button>
        <button type="button" className="modalSaveBtn" disabled={isSubmitting} onClick={handleSubmit(onSubmit)}>
          {isSubmitting ? 'Saving…' : 'Save'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default Dashboard;
